import React, { Component } from 'react';
import { Formik, Form } from 'formik';
import { Label, Input, FormGroup } from 'reactstrap';
import { withRouter } from 'react-router-dom';

import queryString from "query-string";


import DatePickerField from "../forms/DatePickerField";
import AccountTimesheetTable from "./widgets/AccountTimesheetTable";



import "./TimesheetByStudent.css";


class TimesheetByDateRange extends Component {
    static displayName = TimesheetByDateRange.name;

    constructor(props) {
        super(props);

        let params = queryString.parse(props.location.search)

        let certificationFilterValue = "All";

        this.state = {
            loading: true,
            startDate: this.getLastSaturday(new Date()), 
            endDate: this.getNextFriday(new Date()),

            filterBySubmissionDate : false,
            filterByCertificationDate : false,

            certificationFilter: params.certificationFilter ? params.certificationFilter : "All"
        };

        this.props.store.updateBanner("Timesheet by Date Range");

        this.toggleFilterBySubmissionDate = this.toggleFilterBySubmissionDate.bind(this);
        this.toggleFilterByCertificationDate = this.toggleFilterByCertificationDate.bind(this);

        this.updateCertificationFilter = this.updateCertificationFilter.bind(this);

        this.updateStartDate = this.updateStartDate.bind(this);
        this.updateEndDate = this.updateEndDate.bind(this);

        this.filterAccountsByDate = this.filterAccountsByDate.bind(this);
    }

    updateStartDate(date) {
        console.log(date)
        this.setState({ startDate: date })
    }

    updateEndDate(date) {
        console.log(date)
        this.setState({ endDate: date })
    }

    toggleFilterBySubmissionDate(event) {
        this.setState({
            filterBySubmissionDate : true,
            filterByCertificationDate: false
        });
    }

    toggleFilterByCertificationDate(event) {
        const currFilterValue = this.state.filterByCertificationDate;
        this.setState({
            filterBySubmissionDate : false,
            filterByCertificationDate: true        
        });
    }

    updateCertificationFilter(event) {
        this.setState({
            certificationFilter : event.target.value,
        });
    }


    getLastSaturday(date) {
        // Code to check that date and dayOfWeek are valid left as an exercise ;)
    
        var resultDate = new Date(date.getTime());
    
        resultDate.setDate(date.getDate() + (-7 + 6 - date.getDay()) % 7);
    
        return resultDate;
    }

    getNextFriday(date) {
        // Code to check that date and dayOfWeek are valid left as an exercise ;)
    
        var resultDate = new Date(date.getTime());
    
        resultDate.setDate(date.getDate() + (7 + 5 - date.getDay()) % 7);
    
        return resultDate;
    }


    displayFilters() {

        return (
            <React.Fragment>
            <div className="row">
                <div className="col-12 col-md-4 align-self-center d-flex flex-column">
                    <h2 className="h5 mb-4">Select a Search Type:</h2>
                        <Label check>
                            <Input type="radio" name="filterVal" value={this.toggleFilterBySubmissionDate}  onChange={this.toggleFilterBySubmissionDate} />{' '}
                            Timesheet By Submission Date
                        </Label>

                        <Label check>
                            <Input type="radio" name="filterVal" value={this.toggleFilterByCertificationDate}  onChange={this.toggleFilterByCertificationDate} />{' '}
                            Timesheet By Certification Date
                        </Label>

                        <h3 className="h5 d-block">Include in search:</h3>
                        <select className="form-control" 
                            name="certificationFilter" 
                            value={this.state.certificationFilter} 
                            onChange={this.updateCertificationFilter}
                        >
                            <option value="All">All</option>
                            <option value="Certified">Certified</option>
                            <option value="Uncertified">Uncertified</option>
                        </select>

                        {/*<FormGroup className="d-flex flex-column mt-2">
                            <h3 className="h5 d-block">Include in search:</h3>
                            
                            <Label check>
                                <Input type="checkbox" name="submissionFilter" checked={this.state.certifiedFilter}  onChange={this.toggleCertifiedFilter} />{' '}
                                Certified Timesheets
                            </Label>

                            <Label check>
                                <Input type="checkbox" name="certificationFilter" checked={this.state.uncertifiedFilter}  onChange={this.toggleUncertifiedFilter} />{' '}
                                Uncertified Timesheets
                            </Label>
        </FormGroup>*/}
                </div>
                <div className="col-12 col-md-6">
                    <Formik
                        onSubmit={(values) => true }
                        initialValues={{ startDate: this.state.startDate, endDate: this.state.endDate }}
                        validate={values => {}}
                    >
                        <Form>
                            <DatePickerField name="startDate" onChange={this.updateStartDate} label="Start Date" disabled={!this.state.filterByCertificationDate && !this.state.filterBySubmissionDate} />
                            
                            <DatePickerField name="endDate" onChange={this.updateEndDate} label="End Date"  disabled={!this.state.filterByCertificationDate && !this.state.filterBySubmissionDate} />
                        </Form>
                    </Formik>
                </div>
            </div>
            </React.Fragment>
        );
    }



    render() {
        return (
            <div>
                {this.displayFilters()}
                <div className="row">
                    {this.displayTimesheets()}
                </div>
            </div>
        )
    }


    filterAccountsByDate(accounts) {

        const filtered_accounts = accounts.map(account => {
            account = account.include(["student", "timestamp", "timesheet"]);

            let timesheets = account.timesheets;

            if (timesheets && timesheets.length > 0) {
                timesheets = timesheets.filter((timesheet) => {

                        //Make sure timesheet EXISTS
                        if (timesheet != null) {
                            //Ensure it is submitted - we don't show unsubmitted timesheets to admins
                            if (timesheet.isFinal == false) {
                                return false;
                            }

                            //If we have a cert or uncertified filter disabled
                            if (this.state.certificationFilter === "Certified") {
                                if(!timesheet.isCertified) {
                                    return false;
                                }
                            }
                            //If we have a cert or uncertified filter disabled
                            if (this.state.certificationFilter === "Uncertified") {
                                if(timesheet.isCertified) {
                                    return false;
                                }
                            }

                            //Make sure it falls under the cert date filter
                            if (this.state.filterByCertificationDate && timesheet.isCertified ) {
                                return (
                                    new Date(timesheet.dateCertified) >= new Date(this.state.startDate)
                                    && (this.state.endDate ? new Date(timesheet.dateCertified) <= new Date(this.state.endDate) : true)
                                );
                            }
                            //Make sure it falls under the cert date filter
                            else if (this.state.filterBySubmissionDate && timesheet.isFinal) {
                                return (
                                        new Date(timesheet.dateSubmitted) >= new Date(this.state.startDate)
                                        && (this.state.endDate ? new Date(timesheet.dateSubmitted) <= new Date(this.state.endDate) : true)
                                    );
                            }

                            return false;
                        }
                    });
                account.timesheets = timesheets;
            }
            else {
                account.timesheets = []
            }
            return account;
        });

        return filtered_accounts;
    }

    
    displayTimesheets() {
        if (this.state.startDate) {

            let accounts = this.props.store.accounts.collection;

            accounts = this.filterAccountsByDate(accounts)

            accounts = accounts.filter(account => account.timesheets.length > 0)

            if (accounts.length > 0) {
                return (
                    <AccountTimesheetTable 
                        showStudentName={true}
                        showFopal={true}
                        showCertifiedDate={true} 
                        showSubmittedDate={true} 
                        showWeekEndDate={true}
                        accounts={accounts} 
                        store={this.props.store} />
                );
            }
            else {
                return (undefined)
            }
        }
    }
}

TimesheetByDateRange = withRouter(TimesheetByDateRange)

export {TimesheetByDateRange};